__turbopack_context__.v({
  "actionButton": "lxI2Aq_actionButton",
  "actions": "lxI2Aq_actions",
  "description": "lxI2Aq_description",
  "disabled": "lxI2Aq_disabled",
  "header": "lxI2Aq_header",
  "right": "lxI2Aq_right",
  "title": "lxI2Aq_title",
  "titleContainer": "lxI2Aq_titleContainer",
  "titleSection": "lxI2Aq_titleSection",
  "visionLink": "lxI2Aq_visionLink",
});
